<div class="cooking-container">
  <div class="cooking-header" (swipedown)="swipe($event.type)">
    <div class="title">
      <img src="assets/cookingbook/report.svg" alt="" />

      <p>افزودن به لیست خرید</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <div
      class="ingredients-item"
      *ngFor="let item of ingredients; let index = index"
    >
      <div class="title" (click)="toggleIngredients(item._id)">
        <img
          [src]="
            checkSelect(item._id)
              ? 'assets/cookingbook/circle_true.svg'
              : 'assets/cookingbook/circle.svg'
          "
          alt=""
        />

        <p>
          {{ item.food.name }}
        </p>
      </div>
      <div class="description">
        <p>
          {{ getDescription(item) }}
        </p>
        <img
          src="assets/plans/edit-blue.svg"
          (click)="editList(item._id)"
          alt=""
        />
      </div>
    </div>
    <div class="submit-button" (click)="save()">
      ثبت کنید <span>{{ selectedItem.length }}</span>
    </div>
  </div>
</div>
